export interface IClcHtmp {
    id: number;
    recipientAlias: string;
    recipientAbo: string;
    cpra: number;
    txpDate: string;
    swap: number;
    cluster: number;
    position: number;
    potentialDonorAlias: string;
    potentialDonorAbo: string;
    donorAlias: string;
    donorAbo: string;
    clcPoints: number;
}